<template>

    <div>

        <transition name="modal">
            <v-modal-logout v-if="showModal === 'logout'" />
        </transition>

        <v-panel class="maxw-600">
            <template #title>Create Your Company</template>
            <template #body>
                <v-alert :message="error" />
                <form @submit.prevent="createCompany">
                    <v-form-group dir="ver" label="Company Name">
                        <v-input placeholder="My Company Name" :model="params.name" @input="params.name = $event" />
                    </v-form-group>
                    <v-button class="mb-30" btn-type="submit" :loading="loading" @click.native="createCompany" btn-block>Continue</v-button>
                </form>
                <p class="small text-center mb-0"><a href="#" @click.prevent="logout">Log Out</a></p>
            </template>
        </v-panel>

    </div>

</template>

<script>

import ModalLogout from '@modals/misc/ModalLogout';
import UserApi from '@api/UserApi';

export default {

    components: {
        'v-modal-logout': ModalLogout,
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        createCompany() {
            if (this.loading) return;
            this.loading = true;
            UserApi.createCompany(this.params)
                .then((response) => {
                    this.loading = false;
                    this.$router.push({ name: 'projects' });
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        logout() {
            this.$store.commit('showModal', 'logout');
        },

    },

}

</script>
